import { Badge, Button, Heading, Surface, Text } from '@elladx/design-system';
import Modal from '../Modal';
import type { AddressRecord } from '../../types';
import { formatDateTime } from '../../utils/dateFormat';

export default function RecipientDetailsModal({ recipient, onClose, onShip, onEdit, onDelete }: {
  recipient: AddressRecord | null; onClose: () => void; onShip: (recipient: AddressRecord) => void;
  onEdit: (recipient: AddressRecord) => void; onDelete: (recipient: AddressRecord) => void;
}) {
  return <Modal isOpen={Boolean(recipient)} title={recipient?.name || 'Recipient details'} onClose={onClose}>
    {recipient && <div className="management-detail">
      <Surface tone="sage" className="management-summary">
        <Heading as="h3" variant="card">{recipient.name || recipient.company || 'Recipient'}</Heading>
        {recipient.company && <Text>{recipient.company}</Text>}
        <Text>{[recipient.street1, recipient.street2].filter(Boolean).join(', ')}</Text>
        <Text>{[recipient.city, recipient.state, recipient.zip, recipient.country].filter(Boolean).join(', ')}</Text>
      </Surface>
      <dl className="management-facts">
        {recipient.gift && <><dt>Gift</dt><dd>{recipient.gift === 'Tshirt' ? `T-shirt ${recipient.tshirt_size || ''}` : recipient.gift}</dd></>}
        {recipient.email && <><dt>Email</dt><dd>{recipient.email}</dd></>}
        {recipient.phone && <><dt>Phone</dt><dd>{recipient.phone}</dd></>}
        <dt>Shipments</dt><dd><Badge>{recipient.shipment_stats?.count || 0}</Badge></dd>
        <dt>Last shipped</dt><dd>{recipient.shipment_stats?.last_shipped_at ? formatDateTime(recipient.shipment_stats.last_shipped_at) : 'Not shipped yet'}</dd>
      </dl>
      <Text tone="muted">Check the package and get new rates for every shipment.</Text>
      <div className="management-actions"><Button type="button" variant="primary" onClick={() => onShip(recipient)}>Ship to this recipient</Button><Button type="button" variant="secondary" onClick={() => onEdit(recipient)}>Edit recipient</Button><Button type="button" variant="danger-secondary" onClick={() => onDelete(recipient)}>Delete recipient</Button></div>
    </div>}
  </Modal>;
}
